import Vue from "vue";

export async function fetchLinks({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `frontend/links?view_as=${full_legal_number}`,
    });
    
    return data
  } catch (e) {
    return e
  } finally {
  }
}